import qs from "qs";
import {
  ApiResponse,
  ClientUIResponse,
  FdpDriverAccountUIResponse,
  FdpUIResponse,
  ArrayDataResponse,
  SingleFdpResponse,
  StoreDataUIResponse,
  UserDataUIResponse,
  UserUIResponse,
  FdpToParcelCenterMappingResponse,
  DriverSelectedEmailUIResponse,
  StoreFdpsUIResponse,
} from "../../models/ApiResponse";
import { RouteCheckoutRequest, UpdateFdpInvoiceRequest } from "../../models/requestModels/RtsRequestAdminPanel";
import {
  AddFdpRequest,
  BulkFdpRequest,
  DriverClientEmailRequest,
  updateFdpRequest,
} from "../../models/requestModels/fdpRequest";
import { FdpDriverClientAccount } from "../../models/responseModels/loginResponse";
import { axiosRequests } from "../axiosRequest";

export const FdpAgent = {
  getFdpsList: () =>
    axiosRequests.get<FdpUIResponse>(`/fdc-commandops/fdp/all`),
  getFdpsToParcelCenterMappingList: () =>
    axiosRequests.get<FdpToParcelCenterMappingResponse>(
      `/fdc-commandops/fdp/all-fdp-parcel-center-mappings`
    ),
  getFdpUsersList: (fdpId: number) =>
    axiosRequests.get<UserUIResponse>(`/auth/fdp/user?fdpId=${fdpId}`),
  addFdp: (fdpDto: AddFdpRequest) =>
    axiosRequests.post<ApiResponse>(`/auth/fdp/new`, fdpDto),
  addBulkFdps: (fdps: BulkFdpRequest) =>
    axiosRequests.post<ArrayDataResponse>(`/auth/fdp/bulk/new`, fdps),
  deleteFdp: (fdpId: string) =>
    axiosRequests.delete<ApiResponse>(`/auth/fdp/deactive?fdpId=${fdpId}`),
  updateFdpStatus: (fdpIds: string[], active: boolean) =>
    axiosRequests.put<ApiResponse>(
      `/auth/fdp/status/update?active=${active}`,
      fdpIds
    ),
  updateFdp: (updateFdpRequest: updateFdpRequest) =>
    axiosRequests.put<ApiResponse>(`/auth/fdp/update`, updateFdpRequest),
  getFdpDriverClientEmails: () =>
    axiosRequests.get<FdpDriverAccountUIResponse>(
      `/fdc-commandops/fdp/clients/driver/emails`
    ),
  getFdpList: () => axiosRequests.get<FdpUIResponse>("/fdc-commandops/fdp"),
  getFdpListByClient: (clientId: number) =>
    axiosRequests.get<FdpUIResponse>(
      `/fdc-commandops/fdp/client?id=${clientId}`
    ),
  getDriversByFdp: (fdpId: number) =>
    axiosRequests.get<UserDataUIResponse>(
      `/fdc-commandops/fdp/drivers?fdpId=${fdpId}`
    ),
  getStoresByFdpId: (fdpId: number, clientId: number) =>
    axiosRequests.get<StoreDataUIResponse>(
      `/fdc-commandops/fdp/stores?fdpId=${fdpId}&clientId=${clientId}`
    ),
  getFdpDriverSelectedEmail: () =>
    axiosRequests.get<DriverSelectedEmailUIResponse>(
      `/fdc-commandops/fdp/driver/selected/email`
    ),
  getFdpDriverCredsMappingWithClientEmails: () =>
      axiosRequests.get<FdpDriverAccountUIResponse>(
        `/fdc-commandops/fdp/driver/creds-mapping`
      ),
  updateFdpDriverSelectedAcc: (selectedAcc: FdpDriverClientAccount, comment: string) =>
    axiosRequests.post<ApiResponse>(
      `/fdc-commandops/fdp/driver/save/client/account?comment=${comment}`,
      selectedAcc
    ),
  removeFdpDriverSelectedAcc: (toBeRemovedAccount: FdpDriverClientAccount) =>
    axiosRequests.post<ApiResponse>(
      `/fdc-commandops/fdp/driver/remove/client/account`, toBeRemovedAccount
    ),
  fetchFdpAssociatedClients: (fdpId: number) =>
    axiosRequests.get<ClientUIResponse>(
      `/fdc-commandops/fdp/associated/clients?fdpId=${fdpId}`
    ),
  addFdpDriverClientEmail: (driverEmailRequest: DriverClientEmailRequest) =>
    axiosRequests.post<ArrayDataResponse>(
      `/fdc-commandops/fdp/add/driver/email`,
      driverEmailRequest
    ),
  deleteFdpDriverClientEmail: (driverEmailRequest: DriverClientEmailRequest) =>
    axiosRequests.post<ArrayDataResponse>(
      `/fdc-commandops/fdp/delete/driver/email`,
      driverEmailRequest
    ),
  saveRouteCheckout: (routecheckoutReq: RouteCheckoutRequest) =>
    axiosRequests.post<any>(
      `/fdc-commandops/fdp/save/driver/email/ui`,
      routecheckoutReq
    ),
  getFdpListByStore: (storeIds: number[]) =>
    axiosRequests.getWithQueryParam<StoreFdpsUIResponse>("/fdc-commandops/fdp/for-store", {
      params: { storePrimaryIds: storeIds },
      paramsSerializer: (params: any) => qs.stringify(params, { arrayFormat: 'repeat' }),
  }),
  getFdpDriverEmailsByFdpAndStore: (fdpId: number, storeId: number) => 
        axiosRequests.get<ArrayDataResponse>(
          `/fdc-commandops/fdp/driver-emails/for-store?storePrimaryId=
          ${storeId}&fdpId=${fdpId}`),

  updateInvoiceStatusByPayableDate: (updateFdpInvoiceRequest: UpdateFdpInvoiceRequest) => 
    axiosRequests.put<ApiResponse>(`/fdc-invoice/fdp-invoices/update_fdp_status`, updateFdpInvoiceRequest),
};
